import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import {
  selectCPMFTrackingForecastSubpage,
  selectCPMFTrackingForecastTimeFrequency,
  setTimeFrequency as setTimeFrequencyRedux,
} from 'redux/reducers/meteorologyFieldsTrackingForecastControlPanelReducer';
import { useGetTrackingForecastTimeFrequenciesQuery } from 'services/api/Meteorology/Fields/TrackingForecast/DetailedView';
import { SUBPAGE_SUBMENU_OPTIONS } from 'types/Meteorology/Fields/TrackingForecast/DetailedView';

export default function useTimeFrequency() {
  const subpage = useSelector(selectCPMFTrackingForecastSubpage);
  const submenu = SUBPAGE_SUBMENU_OPTIONS[subpage];
  const { data } = useGetTrackingForecastTimeFrequenciesQuery({ submenu });
  const timeFrequencies = data || [];

  const selectedTimeFrequencyValue: string | undefined = useSelector(
    selectCPMFTrackingForecastTimeFrequency,
  );
  const selectedTimeFrequency = timeFrequencies.find(
    (tf) => tf.value === selectedTimeFrequencyValue,
  );
  const setTimeFrequency = (value: string) => {
    const timeFrequency = timeFrequencies.find((dt) => dt.value === value);
    if (timeFrequency) store.dispatch(setTimeFrequencyRedux(value));
  };

  return { timeFrequencies, selectedTimeFrequency, setTimeFrequency };
}
